/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
 
import { cva, type VariantProps } from 'class-variance-authority';

export const botInfoNameVariants = cva(
  ['leading-[28px]', 'font-medium', 'text-20px'],
  {
    variants: {
      showBackground: {
        true: ['coz-fg-images-user-name'],
        false: ['coz-fg-plus'],
      },
    },
  },
);

export type BotInfoVariantProps = VariantProps<typeof botInfoNameVariants>;

export const typeSafeBotInfoNameVariants: (
  props: BotInfoVariantProps,
) => string = botInfoNameVariants;
